module.exports = __webpack_public_path__ + "static/img/会议.5ce4eb05.png";